import { Box, Flex, Text } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import ContentArea from "./ContentArea";
import Link from "next/link";
import SimpleButton from "./Buttons/SimpleButton";
import { modifyDatoImgUrlToStatic } from "./utils";


let TopBannerKarmaBook = ({ sectionContent }) => {
    return <Box
        backgroundImage={{
            base: modifyDatoImgUrlToStatic(sectionContent?.[0]?.mobileImage?.url),
            md: modifyDatoImgUrlToStatic(sectionContent?.[0]?.desktopImage?.url)
        }}
        height={{ base: '800px', md: '784px', lg: '784px', xl: '977px', '2xl': '977px' }}
        backgroundSize="cover"
        mt={'-50px'}
        pt={{ base: '5rem', md: '9rem', lg: '8rem' }}
        bgPosition={{base: 'unset', md: '49%', lg: 'unset'}}
    >
        <Flex ml={{base:'0px', md: '2rem', lg: '0px'}} flexDir={{ base: 'column-reverse', md: 'row' }} justifyContent={'center'} gap={{base: 5, md: 0, lg: 10}} alignItems={'center'} width={'100%'}>
            <Box
            bgGradient={{base: 'linear-gradient(360deg, rgba(3, 0, 64, 0.5) 0%, rgba(3, 0, 64, 0) 100%)',md:'unset'}}
            pb={{base:'22px', md: '0px'}}
            display={'flex'} justifyContent={'center'} flexDir={'column'}
            alignItems={'center'} width={{base: '100%', md: 'auto'}}
            >
                <Text
                    textAlign={'center'}
                    fontSize={{ base: '64px', md: '86px', xl: '110px' }}
                    color={'#FFFFFF'}
                    fontWeight={500}
                    fontFamily={'var(--AustinMedium)'}
                    lineHeight={{ base: '72.15px', md: '105.42px', lg: '131.93px' }}
                >{sectionContent?.[0]?.title}</Text>

                <Box
                    mt={{ base: '-5px', lg: '-15px' }}
                    pb={{ base: '30px', md: '10px' }}
                    borderBottom={{ base: 'none', md: '1px solid #fff' }}>
                    <ContentArea
                        pb={'0px'}
                        mx={'0px'}
                        tAlign={'center'}
                        fontFamily={'var(--FedraSansStd-medium)'}
                        color={'#FFFFFF'}
                        mainContent={sectionContent?.[0]?.titleSubtext?.value}
                        sectionContent={sectionContent?.[0]?.titleSubtext}
                        font={{ base: '16.96px', md: '24px', lg: '31.02px' }}
                        fontWeight={500}
                        lineHeight={{ base: '21px', md: "39.58px" }}
                    />
                </Box>

                <Box display={{ base: 'none', md: 'block' }}
                    mb={{ md: '4.5rem', md: '2rem', lg: '4rem' }}
                    mt={{base: '0px', md: '-0.4rem', lg: '0px'}}
                >
                    <ContentArea
                        pb={"0px"}
                        width={{md: '376px', lg:'351px'}}
                        tAlign={'center'}
                        fontFamily={'FedraSerifAStdBook'}
                        color={'#FFFFFF'}
                        mainContent={sectionContent?.[0]?.bottomText?.value}
                        sectionContent={sectionContent?.[0]?.bottomText}
                        font={{ base: '16.96px', md: '24px', lg: '31.02px' }}
                        fontWeight={400}
                        lineHeight={"39.58px"}
                        maxW={'100%'}
                    />
                </Box>

                <Box display={{ base: 'block', md: 'none' }} mb={'30px'}>
                    <LazyLoadImageComponent
                        src={modifyDatoImgUrlToStatic(sectionContent?.[2]?.image?.url)}
                        alt=""
                        width={{ base: '207.52px', md: "276.47px" }}
                        height="100%"
                    />
                </Box>

                <SimpleButton sectionContent={{...sectionContent?.[0]?.button?.[0], buttonStyle: 'karma-transparent'}} />
            </Box>

            <Box ml={{ base: '3rem', md: '0rem', lg: '3rem' }}>
                <LazyLoadImageComponent
                    src={modifyDatoImgUrlToStatic(sectionContent?.[1]?.image?.url)}
                    alt=""
                    width={{ base: '272px', md: '413px', 'xl': "558px" }}
                    height="100%"
                />
            </Box>
        </Flex>
    </Box>
}

export default TopBannerKarmaBook;